import { useContext } from "solid-js";
import { AppControllerContext } from "./AppControllerContext";
export function Footer() {
    const appController = useContext(AppControllerContext);
    if (appController) {
        return (<footer id="layout-footer" style="display: flex; flex-direction: column;">
                <div style="height: 1lh; display: flex; flex-direction: row; justify-content: end; align-items: center; color: #fff; font-size: xx-small;">
                    Version: {appController.appSettings.CurrentVersion}
                </div>
            </footer>);
    }
    else {
        throw "appController from context is undefined!";
    }
}
